<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("PRODUCTS.ADD_UNIT_OF_MEASURE") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <unit-of-measure-form
              :loading="loading"
              :unitOfMeasureData="unitOfMeasure"
              :formErrors="formErrors"
              @unitOfMeasureSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultUnitOfMeasure from "./defaultUnitOfMeasure";
import UnitOfMeasureForm from "./partials/UnitOfMeasureForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    UnitOfMeasureForm,
  },

  mixins: [alertLeave],

  data() {
    const unitOfMeasure = cloneDeep(defaultUnitOfMeasure);
    return {
      unitOfMeasure: unitOfMeasure,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List UnitOfMeasures" });
    },

    viewUnitOfMeasure(unitOfMeasure) {
      this.alertLeave = false;
      this.$router.push({
        name: "View UnitOfMeasure",
        params: { id: unitOfMeasure.id },
      });
    },

    async handleSubmit(unitOfMeasure) {
      this.loading = true;

      const unitOfMeasureData = cloneDeep(unitOfMeasure);
      delete unitOfMeasureData.id;

      try {
        await this.$store.dispatch("unitOfMeasures/add", unitOfMeasureData);
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.UNIT_OF_MEASURE_ADDED"),
        });
        const unitOfMeasure = await this.$store.getters[
          "unitOfMeasures/unitOfMeasure"
        ];
        this.viewUnitOfMeasure(unitOfMeasure);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
